var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNaverBlog = function SvgNaverBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "naver_blog_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".naver_blog_svg__st0{fill:#31a836}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "naver_blog_svg__st0",
    d: "M5.24 9.08c-.46 0-.83.37-.83.83 0 .46.37.83.83.83.46 0 .83-.37.83-.83a.841.841 0 0 0-.83-.83zM13.4 9c-.49 0-.89.4-.89.89s.4.89.89.89.89-.4.89-.89-.4-.89-.89-.89z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "naver_blog_svg__st0",
    d: "M20.79.87H3.21C1.44.87 0 2.31 0 4.08v10.43c0 1.77 1.44 3.21 3.21 3.21h6.21l2.11 4.98s.15.43.5.43.5-.43.5-.43l2.11-4.98h6.15c1.77 0 3.21-1.44 3.21-3.21V4.08C24 2.31 22.56.87 20.79.87zM7.54 10.09c-.01 1.91-1.98 1.96-1.98 1.96-.76 0-1.19-.51-1.19-.51v.34H2.93V5.97c-.01 0-.01 0 0 0 .09.01 1.44 0 1.44 0v2.27c.33-.58 1.31-.57 1.31-.57 2.13.19 1.86 2.42 1.86 2.42zm2.53-2.24v4.06H8.66V7.89c0-.55-.68-.7-.68-.7V5.77c2.25.1 2.09 2.08 2.09 2.08zm3.33 4.21c-1.3 0-2.36-.97-2.36-2.17s1.05-2.17 2.36-2.17c1.3 0 2.36.97 2.36 2.17s-1.06 2.17-2.36 2.17zm7.7 0s.02 2.06-2.07 2.06h-.64v-1.33h.38s.88.08.87-1.27c0 0-.17.55-1.41.55 0 0-1.75-.13-1.75-1.83v-.66s.04-1.77 1.96-1.91c0 0 .76-.08 1.22.55v-.44h1.43v4.28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "naver_blog_svg__st0",
    d: "M18.87 9.02a.87.87 0 1 0 .001 1.741.87.87 0 0 0-.001-1.741z"
  })));
};
export default SvgNaverBlog;